import { Maybe, nothing } from 'maybeasy';
import { createContext } from 'react';
import { ExperienceDictionaryEntryResponse } from '../../ExperiencesDictionary/Types';

export const PortalExperienceContext =
  createContext<Maybe<ExperienceDictionaryEntryResponse>>(nothing());
